(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5921],{

/***/ 42423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ getMessageStatus; },
  "OA": function() { return /* binding */ getProductsById; },
  "$y": function() { return /* binding */ getProfileData; },
  "Qi": function() { return /* binding */ getShippingDetails; },
  "qy": function() { return /* binding */ getShippingMethods; },
  "bQ": function() { return /* binding */ handleQuantityChange; },
  "B8": function() { return /* binding */ removeCartItem; },
  "nc": function() { return /* binding */ setShippingAddress; },
  "FX": function() { return /* binding */ updateProductDetailToStore; }
});

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/store/index.js + 1 modules
var store = __webpack_require__(20366);
// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./src/store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(21925);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/utils/cart.js
var cart = __webpack_require__(87292);
;// CONCATENATED MODULE: ./src/utils/removeCart.js
// import { analyticsCB } from "@/components/cart/cartAnalytics"
const removeFromCart = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    /**
   * It removeFrom cart for pay load
   */ const { lineItemId ="" , quantity =0 , isBundle =false , isBundleParent =false , sku =""  } = data;
    const bundlePayload = {
        action: "removeBundleItem",
        customLineItemId: lineItemId,
        sku
    };
    const actions = [
        isBundleParent ? bundlePayload : {
            action: isBundle ? "removebundle" : "removeLineItem",
            lineItemId,
            quantity
        }
    ];
    return actions;
};
const setRemoveCartPayload = function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    /**
   * It removeFrom cart for payload removeBundleItem
   */ const actions = [];
    const allIds = items.filter((item)=>item.id !== "").map((item)=>item.id);
    items.forEach((item)=>{
        const filteredIds = allIds.filter((i)=>i !== item.id);
        // filtering out the combo sku items, to select only parent item if available
        if (!filteredIds.includes(item.bundleParentId) && !item.parentBundleSku && !item.isBundleParent) {
            actions.push({
                action: item.isComboSku || (item === null || item === void 0 ? void 0 : item.bundleParentId) ? "removebundle" : "removeLineItem",
                lineItemId: (item === null || item === void 0 ? void 0 : item.bundleParentId) ? item.bundleParentId : item.id,
                quantity: item.quantity
            });
        } else if (!(item === null || item === void 0 ? void 0 : item.parentBundleSku) && (item === null || item === void 0 ? void 0 : item.isBundleParent)) {
            // else block added for the static bundles only, as we have different payload
            actions.push({
                action: (item === null || item === void 0 ? void 0 : item.isBundleParent) ? "removeBundleItem" : "removeLineItem",
                customLineItemId: item.id,
                sku: item.sku
            });
        }
    });
    return actions;
};

// EXTERNAL MODULE: ./src/js/helperV2.js
var helperV2 = __webpack_require__(41162);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/utils/addTocart.js
var addTocart = __webpack_require__(84003);
;// CONCATENATED MODULE: ./src/components/cart/cartHelper.js












const setShippingAddress = async (data, cb, needAnalytics, errorCb)=>{
    var ref;
    const { user ={}  } = (ref = store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.auth;
    if (data.postalCode && data.postalCode.trim() !== "") {
        var ref1, ref2, ref3;
        const address = {
            postalCode: (ref1 = data.postalCode) === null || ref1 === void 0 ? void 0 : ref1.trim(),
            state: (ref2 = data.state) === null || ref2 === void 0 ? void 0 : ref2.trim(),
            country: (ref3 = data.country) === null || ref3 === void 0 ? void 0 : ref3.trim()
        };
        if (!(data === null || data === void 0 ? void 0 : data.email)) {
            data.email = user === null || user === void 0 ? void 0 : user.sub;
        }
        const { firstName , lastName , streetName , streetNumber , city , email , phone  } = data;
        if (firstName) address.firstName = firstName.trim();
        if (lastName) address.lastName = lastName.trim();
        if (streetName) address.streetName = streetName.trim();
        if (streetNumber) address.streetNumber = streetNumber.trim();
        if (city) address.city = city.trim();
        if (email) address.email = email.trim().toLowerCase();
        if (phone) address.phone = phone.trim();
        const actions = [
            {
                action: "setShippingAddress",
                address: address
            }
        ];
        if (email) actions.push({
            action: "setCustomerEmail",
            email: email.trim().toLowerCase()
        });
        if (user === null || user === void 0 ? void 0 : user.koc) {
            actions.push({
                action: "setCustomType",
                type: {
                    key: "order",
                    typeId: "type"
                },
                fields: {
                    CSRAssociateId: user === null || user === void 0 ? void 0 : user.koc,
                    orderType: "ISC"
                }
            });
        }
        const payload = {
            actions: actions
        };
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentUpdate */.NM)(payload)).unwrap().then((res)=>{
            if ((res === null || res === void 0 ? void 0 : res.type) === "Cart" && res.lineItems.length > 0) {
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
                const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
                const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
                getShippingMethods();
                cb && cb(address.postalCode, "success");
                needAnalytics && needAnalytics("success");
            } else {
                if (!phone) {
                    cb && cb(address.postalCode, "failure", "no items to ship in cart");
                }
            }
        }).catch((error)=>{
            errorCb && errorCb(error);
            if (!phone) {
                cb && cb(address.postalCode, "failure", "failed to set shipping address.");
            }
        });
    }
};
const getShippingMethods = async ()=>{
    var ref, ref1, ref2, ref3;
    const cart = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const lineItemsLength = (cart === null || cart === void 0 ? void 0 : cart.lineItems) ? cart.lineItems.length : 0;
    // const taxedPrice = getState().cart?.cart?.data?.taxedPrice;
    const shippingZip = localStorage.getItem("shippingZip");
    const { taxedPrice ="" , shippingAddress: { postalCode: shippingAddressPostCode = ""  } = {}  } = cart;
    let shippingCost = 0;
    var ref4;
    shippingCost = Number(((ref4 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.shippingTotal) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref4 !== void 0 ? ref4 : 0) / 100).toFixed(2);
    let promoCodes = [];
    if ((cart === null || cart === void 0 ? void 0 : (ref3 = cart.customLineItems) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
        promoCodes = promoCodes.concat(await (0,helper/* getShippingDiscountPromoCodes */.oH8)(cart));
        promoCodes.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === "shipping";
        }).forEach((item)=>{
            shippingCost = Number(shippingCost) + Number(item.discount);
        });
    }
    if (lineItemsLength > 0 && shippingZip && shippingZip.trim() !== "" && shippingAddressPostCode && (!taxedPrice || !shippingCost || shippingCost && shippingCost * 1 === 0)) {
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentCart */.pw)()).unwrap().then((response)=>{
            if (response && response["shipping-details"]) {
                updateProductDetailToStore(response);
            } else {
                getShippingDetails().then((response)=>{
                    updateProductDetailToStore(response);
                }).catch((error)=>{
                    console.error(error);
                });
            }
        });
    }
};
const getProfileData = async function() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let profile = {};
    try {
        const res = await store/* store.dispatch */.h.dispatch((0,checkoutSlice/* getProfile */.Ai)());
        if (res && res.data) {
            var ref, ref1, ref2, ref3;
            localStorage.setItem("profile-version", (ref = res.data) === null || ref === void 0 ? void 0 : ref.version);
            profile = res.data;
            profile.postalCode = (ref1 = profile === null || profile === void 0 ? void 0 : profile.addresses[0]) === null || ref1 === void 0 ? void 0 : ref1.postalCode;
            const profileAddr = profile === null || profile === void 0 ? void 0 : (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
            profile.addresses = profile === null || profile === void 0 ? void 0 : (ref3 = profile.addresses) === null || ref3 === void 0 ? void 0 : ref3.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
            if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,helper/* arrayMove */.RpN)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        errorMsg && store/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: errorMsg,
            isVisible: true
        }));
    }
    return profile;
};
const removeCartItem = async function(data) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref, ref1;
    const { id ="" , quantity =0 , isComboSku =false , isBundleParent =false , sku  } = data;
    let payload;
    const { shippingAddress: { postalCode =""  } = {}  } = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    if (!Array.isArray(data)) {
        const payloadData = {
            lineItemId: id,
            quantity,
            isBundle: isComboSku,
            isBundleParent,
            sku
        };
        payload = removeFromCart(payloadData);
    } else {
        payload = setRemoveCartPayload(data);
    }
    payload = payload.reduce((acc, ini)=>{
        if (!acc.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.lineItemId) === (ini === null || ini === void 0 ? void 0 : ini.lineItemId);
        }).length) {
            acc.push(ini);
        }
        return acc;
    }, []);
    const body = {
        actions: payload
    };
    await store/* store.dispatch */.h.dispatch((0,cartSlice/* removeFromCartLineItem */.Z5)(body)).unwrap().then((res)=>{
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
        const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
        const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
        if (res.lineItems.length > 0) {
            if (postalCode) {
                getShippingMethods();
            }
        } else {
            (0,cart/* deleteFromCart */.EI)(cb);
        }
    });
};
const getProductsById = async (ids)=>{
    let query = "";
    ids.forEach((id, i)=>{
        query += '"'.concat(id, '"');
        if (i + 1 !== ids.length) query += ", ";
    });
    try {
        const response = await store/* store.dispatch */.h.dispatch((0,cartSlice/* recentlyViewed */.er)(query)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.results) {
                return res.results;
            }
        });
        if (response) return response;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
};
const getShippingDetails = async ()=>{
    return new Promise(async (resolve, reject)=>{
        var ref, ref1, ref2;
        const cart = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        const shippingDetails = {
            "shipping-details": {
                results: []
            },
            shippingCost: true
        };
        const response = await api/* apim.get */.TH.get("".concat(constants.shippingCostEndPoint, "?cartId=").concat(cart === null || cart === void 0 ? void 0 : cart.id));
        shippingDetails["shipping-details"]["results"] = response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.results;
        if (response) {
            resolve(shippingDetails);
        } else {
            reject(new Error("Cannot ship to your location"));
        }
    });
};
const updateProductDetailToStore = (response)=>{
    var ref, ref1, ref2, ref3;
    var ref4;
    const validProducts = (ref4 = (ref = response["shipping-details"]) === null || ref === void 0 ? void 0 : (ref1 = ref.results) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>!item.warningMessage)) !== null && ref4 !== void 0 ? ref4 : [];
    var ref5;
    const inValidProducts = (ref5 = (ref2 = response["shipping-details"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.results) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>item.warningMessage)) !== null && ref5 !== void 0 ? ref5 : [];
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setShipping */.YO)(validProducts));
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setNoshipping */.qT)(inValidProducts));
};
const getMessageStatus = (info)=>{
    const { data , email , hideAlerts , i18n , checkoutMode , isMobile , alert ={}  } = info;
    if (data.cancelled || email || !hideAlerts) {
        if (isMobile) {
            if (alert.show) {
                return true;
            } else if (!alert.show && data.outOfStock) {
                return true;
            } else if (!alert.show && !data.outOfStock && data.noShipping) {
                return true;
            } else if (data.category !== "Install Services" && data.category !== "Design Services") {
                if (data.backOrder && data.leadTime && data.quantity > data.availableQty) {
                    return true;
                } else if (!alert.show) {
                    if (data.outOfStock || data.noShipping) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else return false;
        } else {
            return true;
        }
    } else if (!data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg) {
        return true;
    } else if (!checkoutMode && !isMobile) {
        return true;
    } else {
        return false;
    }
};
const handleAddtoCartResponse = (param)=>{
    let { payload  } = param;
    if (payload) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(payload));
    }
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
};
const handleQuantityChange = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id ="" , sku ="" , quantity =0 , isComboSku =false , isBundleParent =false , stockCheck , cb , staticText ={}  } = data;
    let additionalInfo = {};
    var ref;
    const { cart: { qtyLoading =false , cart: { lineItems =[]  } = {}  } = {}  } = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const cartItem = (ref1 = lineItems.find((item)=>{
        const { custom: { fields: { isBundleChildItem =false  } = {}  } = {} , variant: { sku: variantSku = ""  } = {}  } = item;
        if (isComboSku) {
            if (!isBundleChildItem && variantSku === sku) return item;
        } else if (variantSku === sku) {
            return item;
        }
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { custom: { variant: { attributes =[]  } = {} , fields: { roomInfo ="" , isBackOrderable: backorder = false  } = {}  } = {} , quantity: cartQuantity = 0 , id: lineItemId = ""  } = cartItem;
    const brand = get_default()(attributes === null || attributes === void 0 ? void 0 : attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
    if (roomInfo) {
        var ref2, ref3;
        const roomInfoObj = JSON.parse(roomInfo["0"]);
        const { productType ="" , soldByBox , soldByUom  } = roomInfoObj;
        const isTrim = productType === "trim";
        const totalPiecesNo = isTrim ? quantity : soldByBox * quantity;
        const totalOverage = soldByUom > 0 && totalPiecesNo > 0 ? totalPiecesNo / soldByUom : 0;
        const overageVal = Number(cartItem === null || cartItem === void 0 ? void 0 : (ref2 = cartItem.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.overage);
        const overagePercent = overageVal > 0 ? overageVal / 100 : 0;
        const totalNeeded = Math.floor(totalOverage) / (1 + overagePercent);
        additionalInfo = {
            ...roomInfoObj,
            productType: productType,
            totalNeeded: totalNeeded.toFixed(2),
            totalArea: totalOverage.toFixed(2),
            soldByBox: Number(soldByBox),
            soldByUom: Number(soldByUom),
            customQuantity: quantity,
            overage: overageVal.toString(),
            roomInfo: true
        };
    }
    if (quantity > cartQuantity && !stockCheck) {
        var ref4, ref5;
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref4 = cartItem.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            });
            return;
        } else {
            const payload = await (0,addTocart/* addToCartItem */.q)([
                {
                    lineItemId: lineItemId,
                    sku,
                    quantity: quantity - cartQuantity,
                    isBundle: isComboSku,
                    backorder,
                    brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                }
            ]);
            const body = {
                actions: payload
            };
            store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                getShippingMethods();
            // analyticsCB("success", res)
            });
            return;
        }
    }
    // change quantity for bundle
    if (isBundleParent) {
        const payload1 = await (0,addTocart/* addToCartItem */.q)([
            {
                lineItemId: id,
                isBundleParent,
                sku,
                quantity
            }
        ]);
        const body1 = {
            actions: payload1
        };
        store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
            handleAddtoCartResponse(res);
            getShippingMethods();
        });
    } else if (quantity > cartQuantity) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        // Checking stock
        (0,cart/* getStock */.K5)(sku).then(async (stock)=>{
            var ref, ref1;
            // At first time whenever changes made with input feild
            if (Object.keys(additionalInfo).length > 0) {
                if (quantity <= stock) {
                    (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
                    return;
                } else if (quantity > stock) {
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
                    const msg = staticText.outOfStock;
                    cb(msg);
                    return;
                }
            } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.customQuantity) {
                (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                    quantity
                }, cartSlice/* setQtyLoading */.LR);
                return;
            }
            if (quantity > stock) {
                if (stock > cartQuantity) {
                    const payload = await (0,addTocart/* addToCartItem */.q)([
                        {
                            lineItemId: lineItemId,
                            sku,
                            quantity: stock - cartQuantity,
                            isBundle: isComboSku,
                            backorder,
                            brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                        }
                    ]);
                    const body = {
                        actions: payload
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                        cb(stock);
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    // analyticsCB("success", res)
                    });
                    cb(stock);
                } else if (stock === cartQuantity) {
                    const msg1 = staticText.noItemsToShip;
                    cb(msg1);
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* getCart */.dv)()).unwrap().then((rsp)=>{
                    // analyticsCB("success", rsp)
                    });
                } else if (stock > 0) {
                    const payloadData = {
                        lineItemId: lineItemId,
                        quantity: cartQuantity - stock,
                        isBundle: isComboSku,
                        sku
                    };
                    const payload1 = removeFromCart(payloadData);
                    const body1 = {
                        actions: payload1
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    });
                } else {
                    cb();
                }
            } else if (cartQuantity !== stock) {
                const payload2 = await (0,addTocart/* addToCartItem */.q)([
                    {
                        lineItemId: lineItemId,
                        sku,
                        quantity: quantity - cartQuantity,
                        isBundle: isComboSku,
                        backorder,
                        brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                    }
                ]);
                const body2 = {
                    actions: payload2
                };
                store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body2)).unwrap().then((res)=>{
                    handleAddtoCartResponse(res);
                    getShippingMethods();
                // analyticsCB("success", res)
                });
            }
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        }).catch(()=>{
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        });
    } else if (cartQuantity > quantity) {
        var ref6, ref7;
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref6 = cartItem.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            }, cartSlice/* setQtyLoading */.LR);
            return;
        }
        const payloadData = {
            lineItemId: lineItemId,
            quantity: cartQuantity - quantity,
            isBundle: isComboSku,
            sku
        };
        const payload2 = removeFromCart(payloadData, true);
        const body2 = {
            actions: payload2
        };
        store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body2)).unwrap().then((res)=>{
            handleAddtoCartResponse(res);
            getShippingMethods();
        });
    }
};


/***/ }),

/***/ 82476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77529);
/* harmony import */ var _components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4__);






const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { label , size , type , flexible , disabled , onClick , customClass , to , target , className , loading , role , tag , tabIndex =0 , ariaLabel , parentClass , useDefaultClass , testid ="" , ...remainingProps } = props;
    const buttonClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("kf-react-button", "button", className ? className : null, size ? size : "large", type ? type : "primary", flexible ? "flexible" : null, disabled ? "disabled" : null, customClass ? customClass : null, loading ? "loading" : null);
    const ButtonTag = tag === "button" || role === "button" ? "button" : tag === "anchor" ? "a" : (next_link__WEBPACK_IMPORTED_MODULE_3___default());
    const buttonFullClass = useDefaultClass ? (_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonWrapper) : (_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonWrapper) + " " + buttonClass + " " + (parentClass || "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: buttonFullClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonTag, {
            ...remainingProps,
            className: buttonClass,
            onClick: onClick,
            href: to !== null && to !== void 0 ? to : "",
            target: target,
            role: role !== null && role !== void 0 ? role : "",
            tabIndex: tabIndex,
            "aria-label": ariaLabel,
            "aria-disabled": disabled,
            "data-testid": "button".concat(testid ? "-".concat(testid) : ""),
            ref: ref,
            children: [
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loader"
                }),
                label
            ]
        })
    });
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);
Button.propTypes = {
    label: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    flexible: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    customClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    parentClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};


/***/ }),

/***/ 18216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7154);
/* eslint-disable require-jsdoc */ 

const useWindowResize = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    // [1366, 443] [768, 1024] [449, 972]
    // const [size, setSize] = useState([1366, 443])
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
         true ? window.innerWidth : 0,
         true ? window.innerHeight : 0
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (isSsr) {
            return;
        }
        setSize([
            window.innerWidth,
            window.innerHeight
        ]);
        function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        }
        if (!isSsr) {
            window.addEventListener("resize", updateSize);
            updateSize();
        }
        return ()=>window.removeEventListener("resize", updateSize);
    }, [
        isSsr
    ]);
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowResize);


/***/ }),

/***/ 84003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ addToCartItem; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/**
 * It add to cart Utility for pay load
 * @returns the addToCartItem
 */ 
const addToCartItem = async (items)=>{
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref;
    const salesChannels = (ref = CONFIG === null || CONFIG === void 0 ? void 0 : CONFIG.salesChannelConfig) !== null && ref !== void 0 ? ref : {};
    const actionPayload = actionProduct(items, salesChannels, userZipCode);
    return actionPayload;
};
/**
 *  payload to add to cart.
 * @param {items} items The first param.
 * @param {salesChannels} salesChannels The second param.
 * @param {userZipCode} userZipCode The third param.
 * @return {object} the pay load for add to cart
 */ const actionProduct = (items, salesChannels, userZipCode)=>{
    const actions = [];
    let actionData;
    items.forEach((product)=>{
        const { lineItemId , isBundle =false , isBundleProduct =false , isBundleParent =false , sku ="" , quantity =0 , additionalInfo , brand =""  } = product;
        const { roomInfo ="" , customQuantity =0 , overage =""  } = additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : {};
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        const bundlePayload = {
            action: "changeBundleItemQuantity",
            customLineItemId: lineItemId,
            sku,
            quantity
        };
        const payload = {
            action: isBundleProduct ? "addBundleItem" : isBundle ? "addbundle" : "addLineItem",
            sku,
            quantity,
            custom: additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[brand],
                    roomInfo,
                    customQuantity,
                    overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        };
        actions.push(isBundleParent ? bundlePayload : payload);
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
        actionData = [
            ...actions
        ];
    });
    return actionData;
};


/***/ }),

/***/ 77529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__9Vvy_","load":"Button_load___Y_wM"};

/***/ })

}]);